import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../shared/utils/request";
import ProductViewV2 from "../../shared/productViewV2";

const RecomentedProducts = ({ categories }) => {
  const [productData, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await api.get(
          `customer/get-recommended-products/${selectedCategory}`,
        );
        setProducts(data?.data);
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    };

    fetchProducts();
  }, [selectedCategory]);

  return (
    <section className="recommended overflow-hidden pt-80">
      <div className="container container-lg">
        <div className="section-heading flex-between flex-wrap gap-16">
          <h5
            className="mb-0 wow fadeInLeft"
            style={{ visibility: "visible", animationName: "fadeInLeft" }}
          >
            Recommended for you
          </h5>
          <ul
            className="nav common-tab nav-pills recommended-categories wow fadeInRight"
            id="pills-tab"
            role="tablist"
            style={{ visibility: "visible", animationName: "fadeInRight" }}
          >
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link fw-medium text-sm border border-white hover-border-main-600 ${selectedCategory === null ? "active" : ""}`}
                id="pills-all-tab"
                data-bs-toggle="pill"
                onClick={() => setSelectedCategory(null)}
              >
                All
              </button>
            </li>
            {categories.map((category, index) => (
              <li className="nav-item" role="presentation" key={index}>
                <button
                  className={`nav-link fw-medium text-sm border border-white hover-border-main-600 ${selectedCategory === category.id ? "active" : ""}`}
                  id={`pills-${category.name}-tab`}
                  type="button"
                  onClick={() => setSelectedCategory(category.id)}
                >
                  {category.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade active show"
            id="pills-all"
            role="tabpanel"
            aria-labelledby="pills-all-tab"
            tabIndex={0}
          ></div>
          <div className="row g-12">
            {productData.map((product, index) => (
              <ProductViewV2
                key={index}
                product={{
                  id: product?.id,
                  slug: product?.slug,
                  variant_id: product?.product_variants?.[0]?.id,
                  image:
                    product?.product_image ||
                    product?.product_variants?.[0]?.product_image,
                  name: product?.product_name,
                  price: product?.product_variants?.[0]?.sale_price,
                  originalPrice: product?.product_variants?.[0]?.price,
                  quantityType: product?.product_variants?.[0]?.quantity,
                  sold: product?.product_variants?.[0]?.stock,
                  label: product?.label,
                }}
              />
            ))}
          </div>
        </div>
        <div className="text-center mt-40">
          <Link
            to="/collections"
            className="btn btn-main d-inline-flex align-items-center justify-content-center rounded-pill gap-8"
          >
            View All Products
          </Link>
        </div>
      </div>
    </section>
  );
};
export default RecomentedProducts;
